import { render, staticRenderFns } from "./approvedrequest.vue?vue&type=template&id=64493eb4"
import script from "./approvedrequest.vue?vue&type=script&lang=js"
export * from "./approvedrequest.vue?vue&type=script&lang=js"
import style0 from "./approvedrequest.vue?vue&type=style&index=0&id=64493eb4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports